import React, { useEffect, useState, useRef } from 'react';
import { API } from 'aws-amplify';
import { getAPIName } from '../../config';
import {
  Grid,
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio,
  Select,
  MenuItem,
  Divider,
  Typography,
  AppBar,
  Toolbar,
  IconButton,
  InputBase,
  TextField,
  Card,
  CardContent,
  Box,
  CircularProgress,
  Button
} from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { makeStyles, fade } from '@material-ui/core/styles';
import moment from 'moment';
import DealershipSelect from '../dealership-select.component';
import ReactTable, { Column, SortingRule } from 'react-table';
import { Link } from '@reach/router';
import Dealership from '../../_models/Dealership';
import * as XLSX from "xlsx";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
// import AnnouncmentBanner from '../Announcment'
// I am not proud of this long file...
import {
  faArrowUpRightFromSquare,
  faFileExcel,
  faFilePdf
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useSnackbar } from 'notistack';

interface ISAStatistics {
  totalSAContracts: number;
  totalFound: number;
  totalNotFound: number;
  tokenPercentage: number;
}

interface ISAStatisticsTitles {
  totalSAContracts: string;
  totalFound: string;
  totalNotFound: string;
  tokenPercentage: string;
}

const sAStatisticTitles: ISAStatisticsTitles = {
  totalSAContracts: 'Total Contracts',
  totalFound: 'Tokens Found',
  totalNotFound: 'Tokens Not Found',
  tokenPercentage: 'TAuth Compliance',
};

interface IStatistics {
  totalTollsSum: number;
  chargedInvSum: number;
  declinedInvSum: number;
  totalContracts: number;
  totalInvoices: number;
  InvoiceWithoutAuthTokenSum: number;
  authTokenPercentage: number;
  AuthCompliancetrend: number;
  averageInvAmount: number;
  pendingTollsSum: number;
}
interface MetricItem {
  key: keyof IStatistics; // Use IStatistic here
  pastKey: string; // Assuming pastKey is a regular string
  title: string;   // Assuming title is a regular string
}

const styles = () => ({
  headerPadding: {
    paddingBottom: '2rem',
  },
  grow: {
    flexGrow: 1,
  },
});

const useStyles = makeStyles((theme) => ({
  headerPadding: {
    paddingBottom: '2rem',
  },
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: fade(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(1),
    marginLeft: theme.spacing(3),
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(3),
      width: 'auto',
    },
    display: 'flex',
  },
  searchIcon: {
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  inputRoot: {
    color: 'inherit',
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '20ch',
    },
  },
  sectionDesktop: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
    },
  },
  sectionMobile: {
    display: 'flex',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    // width: 200,
  },
  input: {
    color: 'white',
  },
  card: {
    // marginRight: theme.spacing(1),
    // marginLeft: theme.spacing(1),
    // marginBottom: theme.spacing(1),
  },
  subMenu: {
    backgroundColor: '#484a54',
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(1),
  },
  select: {
    color: 'white',
  },
}));
function compareDealerships(a: Dealership, b: Dealership) {
  if (a.name > b.name)
    return 1;
  if (b.name > a.name)
    return -1;
  return 0;
}

function Dashboard(props: any) {
  const classes = useStyles();
  const [searchType, setSearchType] = useState<string>('');
  const [dealershipId, setDealershipId] = useState<number | undefined>(0);
  const [dealershipGroupId, setDealershipGroupId] = useState<
    number | undefined
  >(0);
  const [dashboard, setDashboard] = useState<IStatistics>({
    totalTollsSum: 0,
    pendingTollsSum: 0,
    chargedInvSum: 0,
    declinedInvSum: 0,
    totalContracts: 0,
    totalInvoices: 0,
    InvoiceWithoutAuthTokenSum: 0,
    authTokenPercentage: 0,
    AuthCompliancetrend: 0,
    averageInvAmount: 0,
  });
  const [blurDashboard, setBlurDashboard] = useState(false)
  const [saLoader, setSALoader] = useState(false)
  const [dealershipTableSorted, setDealershipTableSorted] = useState<SortingRule[]>([{ id: "tokenPercentage", desc: true }]);
  const dealershipTablePdfRef = useRef<HTMLDivElement | null>(null);
  const { enqueueSnackbar } = useSnackbar();

  const newMetrics: MetricItem[] = [
    { key: 'totalTollsSum', pastKey: 'pastTotalTollsSum', title: 'Tolls and Violations ($) – excl. fees' },
    { key: 'chargedInvSum', pastKey: 'pastChargedInvSum', title: 'Charged invoices ($)' },
    { key: 'totalContracts', pastKey: 'pastTotalContracts', title: 'Contracts Count' },
    { key: 'pendingTollsSum', pastKey: 'pastPendingTollsSum', title: 'Pending Tolls and Violations ($) – excl. fees' },
    { key: 'declinedInvSum', pastKey: 'pastDeclinedInvSum', title: 'Declined invoices ($)' },
    { key: 'totalInvoices', pastKey: 'pastTotalInvoices', title: 'Invoices Count' },
    { key: 'authTokenPercentage', pastKey: 'pastAuthTokenPercentage', title: '% of Contracts with CC token' },
    { key: 'InvoiceWithoutAuthTokenSum', pastKey: 'pastInvoiceWithoutAuthTokenSum', title: 'Invoices w/out CC ($)' },
    { key: 'averageInvAmount', pastKey: 'pastAverageInvAmount', title: 'Average Invoice Amount ($)' },
  ];

  const [saDetails, setSADetails] = useState<any>({
    totalSAContracts: 0,
    totalFound: 0,
    totalNotFound: 0,
    tokenPercentage: 0,
  });
  const [saRecords, setSARecords] = useState<any>({
    dealerships: [],
    saDetails: [],
  });
  const getPercentageColor = (value: number) => {
  if (value >= 0.8) return "#8fd18f";
  if (value >= 0.6) return "#c6e48b";
  if (value >= 0.4) return "#f3d37a";
  if (value >= 0.2) return "#f5a26f";
  return "#f5a26f";
};
  const [saOption, setSAOption] = useState<any>('');
  const [dealershipOptions, setDealershipOptions] = useState<any[]>([]);
  const [startDate, setStartDate] = useState<any>(moment().startOf('month').format('YYYY-MM-DD'));
  const [endDate, setEndDate] = useState<any>(moment().format('YYYY-MM-DD'));

  const getDealerships = () => {
    let apiName = getAPIName();
    let path = '/dealerships';
    let myInit = {};
    API.get(apiName, path, myInit)
      .then((response) => {
        const results = response.body;
        setDealershipOptions(results.sort(compareDealerships));
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getDealershipGroups = () => {
    let apiName = getAPIName();
    let path = '/dealershipgroups';
    let myInit = {};
    API.get(apiName, path, myInit)
      .then((response) => {
        const results = response.body;
        setDealershipOptions(results);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleSearchTypeChange = (e: any) => {
    let type = e.target.value;
    setSearchType(type);
    if (type === 'dealership') {
      getDealerships();
    } else if (type === 'dealershipGroup') {
      getDealershipGroups();
    }
  };

  const fetchSAForDealershipGroup = async () => {
    let queries: Array<{ name: string; value: string }> = [];
    queries.push({
      name: 'startDt',
      value: new Date(`${startDate}T00:00:00`).toISOString(),
    });
    queries.push({
      name: 'endDt',
      value: new Date(`${endDate}T00:00:00`).toISOString(),
    });
    const paramStrings: string[] = queries.map(
      (q) => `${encodeURIComponent(q.name)}=${encodeURIComponent(q.value)}`
    );

    const path: string = `/dashboard/sa/group/${dealershipGroupId}?${paramStrings.join(
      '&'
    )}`;
    try {
      setSALoader(true)
      const response = await API.get(getAPIName(), path, {});
      setSARecords(response.body);
      setSALoader(false)
    } catch (err) {
      console.log('there was an error');
      console.log(err);
    }
  };

  const fetchSAForDealership = async () => {
    let queries: Array<{ name: string; value: string }> = [];
    queries.push({
      name: 'startDt',
      value: new Date(`${startDate}T00:00:00`).toISOString(),
    });
    queries.push({
      name: 'endDt',
      value: new Date(`${endDate}T00:00:00`).toISOString(),
    });
    const paramStrings: string[] = queries.map(
      (q) => `${encodeURIComponent(q.name)}=${encodeURIComponent(q.value)}`
    );

    const path: string = `/dashboard/sa/dealership/${dealershipId}?${paramStrings.join(
      '&'
    )}`;
    try {
      setSALoader(true)
      const response = await API.get(getAPIName(), path, {});
      setSARecords(response.body);
      setSALoader(false)
    } catch (err) {
      console.log('there was an error');
      console.log(err);
    }
  };

  const fetchDashboardStatistics = async () => {
    let queries: Array<{ name: string; value: string }> = [];
    queries.push({
      name: 'startDt',
      value: new Date(`${startDate}T00:00:00`).toISOString(),
    });
    queries.push({
      name: 'endDt',
      value: new Date(`${endDate}T00:00:00`).toISOString(),
    });
    if (searchType === 'dealership') {
      if (dealershipId) {
        queries.push({
          name: `dealershipid`,
          value: `${dealershipId}`,
        });
      }
    }
    if (searchType === 'dealershipGroup') {
      if (dealershipGroupId) {
        queries.push({
          name: `dealershipgroupid`,
          value: `${dealershipGroupId}`,
        });
      }
    }
    const paramStrings: string[] = queries.map(
      (q) => `${encodeURIComponent(q.name)}=${encodeURIComponent(q.value)}`
    );
    const path: string = `/dashboard?${paramStrings.join('&')}`;
    try {
      setBlurDashboard(true)
      const response = await API.get(getAPIName(), path, {});
      setBlurDashboard(false)
      setDashboard({ ...dashboard, ...response.body });
    } catch (err) {
      console.log('there was an error');
      console.log(err);
    }
  };

  const handleStartDateChange = (e: any) => {
    setStartDate(e.target.value.toString());
  };

  const handleEndDateChange = (e: any) => {
    setEndDate(e.target.value.toString());
  };

  const handleDealershipOptionsDropdown = (e: any) => {
    if (searchType === 'dealership') {
      setDealershipId(e.target.value.toString());
    }
    if (searchType === 'dealershipGroup')
      setDealershipGroupId(e.target.value.toString());
  };

  const handleSAOptionsDropdown = (e: any) => {
    setSAOption(e.target.value.toString());
  };

  useEffect(() => {
    fetchDashboardStatistics();
  }, [dealershipId, dealershipGroupId, startDate, endDate]);

  useEffect(() => {
    fetchSAForDealership();
  }, [dealershipId, startDate, endDate]);

  useEffect(() => {
    fetchSAForDealershipGroup();
  }, [dealershipGroupId, startDate, endDate]);

  // useEffect(() => {
  //   fetchSADetails();
  // }, [saOption]);

  const formatMoney = (statistic: string, value: number) => {
    switch (statistic) {
      case 'totalSAContracts':
      case 'totalFound':
      case 'totalNotFound':
      case 'totalContracts':
      case 'totalInvoices':
        return new Intl.NumberFormat('en-US').format(value);
      case 'tollsPerContracts':
      case 'averageInvAmount':
      case 'pastAverageInvAmount':
      case 'chargedInvSum':
      case 'pastChargedInvSum':
      case 'declinedInvSum':
      case 'pastDeclinedInvSum':
      case 'InvoiceWithoutAuthTokenSum':
      case 'totalTollsSum':
      case 'pastTotalTollsSum':
      case 'pendingTollsSum':
      case 'pastPendingTollsSum':
        return new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',
        }).format(value);
      case 'authTokenPercentage':
      case 'pastAuthTokenPercentage':
      case 'tokenPercentage':
        return new Intl.NumberFormat('en-US', {
          style: 'percent',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(value);
      case 'AuthCompliancetrend':
        if (value > 0) { return '⬈ ' }
        else if (value < 0) { return '⬊ ' }
        else { return '- ' }
    }
  };

  const renderDealershipOptions = (dealershipOptions: any) => {
    let options = dealershipOptions.map((dealership: any) => {
      return (
        <MenuItem key={dealership.id} value={dealership.id}>
          {dealership.name}
        </MenuItem>
      );
    });
    options.unshift(
      <MenuItem key={'0'} value={0}>
        Select Location
      </MenuItem>
    );
    return options;
  };

  const renderSAOptions = (saOptions: any) => {
    let options = saOptions.map((sa: any) => {
      return (
        <MenuItem key={sa.service_advisor_id} value={sa.service_advisor_id}>
          {sa.service_advisor_id}
        </MenuItem>
      );
    });
    options.unshift(
      <MenuItem key={'0'} value={''}>
        Select Service Advisor
      </MenuItem>
    );
    return options;
  };

  const renderDealershipGroupOptions = (dealershipOptions: any) => {
    let options = dealershipOptions.map((dealership: any) => {
      return (
        <MenuItem key={dealership.id} value={dealership.id}>
          {dealership.name}
        </MenuItem>
      );
    });
    options.unshift(
      <MenuItem key={'0'} value={0}>
        Select Group
      </MenuItem>
    );
    return options;
  };

  const SAColumns: Column[] = [
    {
      Header: 'SA Name',
      accessor: 'saName',
    },
    {
      Header: 'Auth Completion %',
      accessor: (record: any) => {
        return new Intl.NumberFormat('en-US', {
          style: 'percent',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(record.tokenPercentage);
      },
      id: 'tokenPercentage',
      sortable: true,
    },
    {
      Header: 'Total Contracts',
      accessor: 'totalContracts',
    },
    {
      Header: 'Total Found',
      accessor: 'totalFound',
    },
    {
      Header: 'Total Not Found',
      accessor: 'totalNotFound',
    },
  ];
const [dealershipTablePage, setDealershipTablePage] = useState(0);
const [dealershipTablePageSize, setDealershipTablePageSize] = useState(10);
const sortDealershipData = (dealerships: any[], sorted: SortingRule[]) => {
  if (!dealerships.length) return dealerships;
  const sortedData = [...dealerships];
  const numericSortIds = new Set([
    "tokenPercentage",
    "totalContracts",
    "totalFound",
    "totalNotFound",
  ]);
  if (sorted && sorted.length > 0) {
    const { id, desc } = sorted[0];
    sortedData.sort((a, b) => {
      if (numericSortIds.has(String(id))) {
        const aVal = Number(a[id]) || 0;
        const bVal = Number(b[id]) || 0;
        return desc ? bVal - aVal : aVal - bVal;
      }
      const aVal = a[id];
      const bVal = b[id];
      if (typeof aVal === "string" && typeof bVal === "string") {
        return desc ? bVal.localeCompare(aVal) : aVal.localeCompare(bVal);
      }
      return 0;
    });
  }
  return sortedData;
};

const maxContracts = Math.max(1, ...saRecords.dealerships.map((d: any) => Number(d.totalContracts || 0)));
const downloadDealershipExcel = (dealerships: any[], totals: any) => {
    if (!dealerships?.length) return;
    // Resolve selected name for header and filename (undefined if nothing selected)
    const selectedOption = dealershipOptions.find((d: any) =>
      String(d.id) === String(searchType === 'dealership' ? dealershipId : dealershipGroupId)
    );
    const selectedName: string | undefined = selectedOption?.name;
    const dateRange = `${startDate} to ${endDate}`;

    const tableRows = [
      ...dealerships,
      { ...totals, tokenPercentage: totals.tokenPercentage },
    ].map((row: any) => ({
      "Dealership Name": row.dealershipName,
      "Auth Completion %":
        row.dealershipName === "TOTAL"
          ? Number(totals.tokenPercentage || 0)
          : Number(row.tokenPercentage || 0),
      "Contracts": Number(row.totalContracts || 0),
      "Contracts with CC": Number(row.totalFound || 0),
      "Contracts without CC": Number(row.totalNotFound || 0),
    }));

    // Only add name row if a location/group is actually selected
    const nameRow: any[][] = selectedName
      ? [[`${searchType === 'dealership' ? 'Location' : 'Group'}: ${selectedName}`]]
      : [];
    const headerAoa: any[][] = [...nameRow, [`Date Range: ${dateRange}`], []];
    const ws = XLSX.utils.aoa_to_sheet(headerAoa);
    XLSX.utils.sheet_add_json(ws, tableRows, { origin: headerAoa.length });
    // Apply percent format to Auth Completion % column (col index 1), offset by header rows
    const percentCol = 1;
    const dataStartRow = headerAoa.length + 1;
    for (let rowIndex = dataStartRow + 1; rowIndex <= dataStartRow + tableRows.length; rowIndex++) {
      const cell = ws[XLSX.utils.encode_cell({ c: percentCol, r: rowIndex - 1 })];
      if (cell && typeof cell.v === "number") {
        cell.z = "0.00%";
      }
    }
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Dealership Summary");
    const filePrefix = selectedName ? selectedName.replace(/[^a-zA-Z0-9_-]/g, '_') : 'Dashboard';
    XLSX.writeFile(wb, `${filePrefix}_Summary_${moment().format("YYYY-MM-DD_HH-mm-ss")}.xlsx`);
  };

  const downloadDealershipPdfScreenshot = async () => {
    const el = dealershipTablePdfRef.current;
    if (!el) return;
    try {
      // Blur active element so the PDF button doesn't appear darkened in the screenshot
      (document.activeElement as HTMLElement)?.blur();
      await new Promise(resolve => setTimeout(resolve, 50));
      // Resolve selected name for header (undefined if nothing selected)
      const selectedOption = dealershipOptions.find((d: any) =>
        String(d.id) === String(searchType === 'dealership' ? dealershipId : dealershipGroupId)
      );
      const selectedName: string | undefined = selectedOption?.name;
      const dateRange = `${startDate} to ${endDate}`;

      const canvas = await html2canvas(el, {
        scale: 1,
        useCORS: true,
        logging: false,
        scrollX: 0,
        scrollY: -window.scrollY,
        windowWidth: document.documentElement.scrollWidth,
        onclone: (_doc: Document, clonedEl: HTMLElement) => {
          clonedEl.querySelectorAll<HTMLElement>('.-sort-asc, .-sort-desc').forEach(th => {
            th.style.boxShadow = 'none';
          });
        },
      });
      const imgData = canvas.toDataURL("image/png", 1.0);
      const pdf = new jsPDF({ orientation: "portrait", unit: "pt", format: "a4" });
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      // Add text header: name line only if a location/group is selected
      let headerTopY = 20;
      if (selectedName) {
        pdf.setFontSize(8);
        pdf.setFont("helvetica", "bold");
        pdf.text(`${searchType === 'dealership' ? 'Location' : 'Group'}: ${selectedName}`, 20, headerTopY);
        headerTopY += 13;
      }
      pdf.setFontSize(8);
      pdf.setFont("helvetica", "normal");
      pdf.text(`Date Range: ${dateRange}`, 20, headerTopY);

      const headerHeight = 50; // space reserved for header text
      const imgWidth = pageWidth;
      const imgHeight = (canvas.height * pageWidth) / canvas.width;
      let heightLeft = imgHeight;
      let position = headerHeight;
      let page = 0;
      while (heightLeft > 0) {
        if (page > 0) {
          pdf.addPage();
          position = 0;
        }
        pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
        heightLeft -= (pageHeight - (page === 0 ? headerHeight : 0));
        position -= pageHeight;
        page += 1;
      }
      const filePrefix = selectedName ? selectedName.replace(/[^a-zA-Z0-9_-]/g, '_') : 'Dashboard';
      pdf.save(`${filePrefix}_Summary_${moment().format("YYYY-MM-DD_HH-mm-ss")}.pdf`);
    } catch (e) {
      console.error("PDF export failed", e);
      enqueueSnackbar("Could not generate PDF. Try again or adjust table page size.", { variant: "error" });
    }
  };

  const renderSATable = () => {
    const { saDetails } = saRecords;
    return (
      <Grid container>
        <Grid xs={12}>
          <ReactTable
            className="-striped -highlight"
            columns={SAColumns}
            data={saDetails}
            loading={saLoader}
            defaultSorted={[
              {
                id: 'saName',
                desc: true,
              },
            ]}
            defaultPageSize={5}
          // manual
          />
        </Grid>
      </Grid>
    );
  };

const renderDealershipTable = () => {
  const { dealerships } = saRecords;
  const totals = {
    dealershipName: "TOTAL",
    tokenPercentage: dealerships.reduce((sum: number, d: any) => sum + Number(d.totalFound || 0),0) /
      (dealerships.reduce((sum: number, d: any) => sum + Number(d.totalContracts || 0),0) || 1),
    totalContracts: dealerships.reduce((sum: number, d: any) => sum + Number(d.totalContracts || 0),0),
    totalFound: dealerships.reduce((sum: number, d: any) => sum + Number(d.totalFound || 0),0),
    totalNotFound: dealerships.reduce((sum: number, d: any) => sum + Number(d.totalNotFound || 0),0),
  };
    const sortedDealerships = sortDealershipData(dealerships,dealershipTableSorted);
    const tableData =
      dealerships.length > 1
        ? [
            ...sortedDealerships,
            {
              ...totals,
              tokenPercentage: -999999,
              actualTokenPercentage: totals.tokenPercentage,
            },
          ]
        : dealerships;
    const paginatedRows = tableData.slice(dealershipTablePage * dealershipTablePageSize, dealershipTablePage * dealershipTablePageSize + dealershipTablePageSize);
    const totalPages = Math.ceil(
      (tableData.length - 1) / dealershipTablePageSize
    );
    const isLastPage = dealershipTablePage === totalPages - 1;
    const finalTableData = isLastPage ? paginatedRows : paginatedRows.filter((d: any) => d.dealershipName !== "TOTAL");
    const columns: Column[] = [
      {
        Header: "Location",
        accessor: "dealershipName",
        Cell: ({ value }) => (
          <div style={{ fontWeight: value === "TOTAL" ? 700 : 500 }}>
            {value}
          </div>
        ),
        width:400
      },
      {
        Header: "% of Contracts with CC token",
        accessor: "tokenPercentage",
        id: "tokenPercentage",
        Cell: ({ value, original }: any) => {
          const percentage =
            original.dealershipName === "TOTAL"
              ? original.actualTokenPercentage
              : value;
          const isTotalRow = original.dealershipName === "TOTAL";
          const p = Number(percentage || 0);
          const formatted = new Intl.NumberFormat("en-US", {
            style: "percent",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }).format(p);

          if (isTotalRow) {
            return (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  minHeight: 24,
                  width: "100%",
                }}
              >
                <span style={{ fontWeight: 700, fontSize: 12, color: "#000" }}>
                  {formatted}
                </span>
              </div>
            );
          }

          return (
            <div
              style={{
                height: "100%",
                display: "flex",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  position: "relative",
                  background: "#edf2f7",
                  borderRadius: 5,
                  overflow: "hidden",
                  height: 24,
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    left: 0,
                    top: 0,
                    bottom: 0,
                    width: `${Math.min(100, Math.max(0, p * 100))}%`,
                    background: getPercentageColor(p),
                  }}
                />
                <span
                  style={{
                    position: "relative",
                    zIndex: 1,
                    width: "100%",
                    textAlign: "center",
                    fontWeight: 700,
                    fontSize: 12,
                    color: "#000",
                    textShadow:
                      "0 0 2px rgba(255,255,255,0.9), 0 0 4px rgba(255,255,255,0.7)",
                  }}
                >
                  {formatted}
                </span>
              </div>
            </div>
          );
        },
      },
      {
        Header: "Contracts",
        accessor: "totalContracts",
        Cell: ({ original }: any) => {
          const total = Number(original.totalContracts || 0);
          const found = Number(original.totalFound || 0);
          const notFound = Number(original.totalNotFound || 0);
          const isTotalRow = original.dealershipName === "TOTAL";

          if (isTotalRow) {
            return (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  minHeight: 24,
                  width: "100%",
                }}
              >
                <span style={{ fontWeight: 700, fontSize: 12, color: "#000" }}>
                  {total.toLocaleString()}
                </span>
              </div>
            );
          }

          return (
            <div
              style={{
                height: "100%",
                display: "flex",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  position: "relative",
                  background: "#edf2f7",
                  borderRadius: 5,
                  overflow: "hidden",
                  height: 24,
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <div style={{display: "flex",width: `${(total / maxContracts) * 100}%`,height: "100%",}}>
                  <div style={{width: `${(found / total) * 100 || 0}%`, background: "#9ba3a8", height: "100%",}}/>
                  <div style={{width: `${(notFound / total) * 100 || 0}%`,background: "#f5a26f",height: "100%",}}/>
                </div>
                <span
                  style={{
                    position: "absolute",
                    left: 8,
                    top: 2,
                    fontWeight: 700,
                    fontSize: 12,
                    color: "#000",
                    textShadow:
                      "0 0 2px rgba(255,255,255,0.9), 0 0 4px rgba(255,255,255,0.7)",
                  }}
                >
                  {total.toLocaleString()}
                </span>
              </div>
            </div>
          );
        },
      },
      {
        Header: "Contracts with CC",
        accessor: "totalFound",
        width:250,
        Cell: (row: any) => {
          const val = Number(row.value || 0).toLocaleString();
          if (row.original.dealershipName === "TOTAL") {
            return <span style={{ fontWeight: 600 }}>{val}</span>;
          }
          return (
            <Link
              to={`contracts`}
              state={{
                dealershipId: row.original.dealershipId,
                authTokenStatusSelection: {
                  name: "Found",
                  value: "Found",
                },
                startDate: moment(
                  startDate,
                  moment.defaultFormat
                ).toDate(),
              }}
              style={{ display: "inline-flex", alignItems: "center", gap: 6, fontWeight: 600 }}
            >
              {val}
              <FontAwesomeIcon icon={faArrowUpRightFromSquare} style={{ fontSize: 12, opacity: 0.85 }} />
            </Link>
          );
        },
      },
      {
        Header: "Contracts without CC",
        width:250,
        accessor: "totalNotFound",
        Cell: (row: any) => {
          const val = Number(row.value || 0).toLocaleString();
          if (row.original.dealershipName === "TOTAL") {
            return <span style={{ fontWeight: 600 }}>{val}</span>;
          }
          return (
            <Link
              to={`contracts`}
              state={{
                dealershipId: row.original.dealershipId,
                authTokenStatusSelection: {
                  name: "Not Found",
                  value: "Not Found",
                },
                startDate: moment(
                  startDate,
                  moment.defaultFormat
                ).toDate(),
              }}
              style={{ display: "inline-flex", alignItems: "center", gap: 6, fontWeight: 600 }}
            >
              {val}
              <FontAwesomeIcon icon={faArrowUpRightFromSquare} style={{ fontSize: 12, opacity: 0.85 }} />
            </Link>
          );
        },
      },
    ];
  return (
    <Grid container>
      <Grid xs={12}>
        <div style={{display:'flex', justifyContent:'end'}}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              border: "1px solid #d7dce1",
              borderRadius: 10,
              overflow: "hidden",
              background: "#fff",
              marginBottom: 12,
              marginRight: 20,
            }}
          >
            <Button
              onClick={() =>
                downloadDealershipExcel(
                  sortedDealerships,
                  totals
                )
              }
                onMouseEnter={(e) =>
                  (e.currentTarget.style.background = "#f5f7fa")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.background = "transparent")
                }
              style={{
                border: "none",
                borderRadius: 0,
                minWidth: 0,
                padding: "8px 14px",
                background: "transparent",

              }}
            >
              <FontAwesomeIcon
                icon={faFileExcel}
                style={{ fontSize: 20, opacity: 0.85 }}
              />
            </Button>

            <div
              style={{
                width: 1,
                alignSelf: "stretch",
                background: "#d7dce1",
              }}
            />

            <Button
              onClick={downloadDealershipPdfScreenshot}
              onMouseEnter={(e) =>
                (e.currentTarget.style.background = "#f5f7fa")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.background = "transparent")
              }
              style={{
                border: "none",
                borderRadius: 0,
                minWidth: 0,
                padding: "8px 14px",
                background: "transparent",
              }}
            >
              <FontAwesomeIcon
                icon={faFilePdf}
                style={{ fontSize: 20, opacity: 0.85 }}
              />
            </Button>
          </div>
        </div>
        <div ref={dealershipTablePdfRef} style={{ background: "#fff" }}>
          <ReactTable
            className="-striped -highlight"
            columns={columns}
            loading={saLoader}
            data={finalTableData}
            sorted={dealershipTableSorted}
            onSortedChange={(sorted: SortingRule[]) => {
              setDealershipTableSorted(sorted);
            }}
            defaultSorted={[{ id: "tokenPercentage", desc: true }]}
            manual={true}
            pages={totalPages}
            page={dealershipTablePage}
            pageSize={dealershipTablePageSize}
            onPageChange={(page) => setDealershipTablePage(page)}
            onPageSizeChange={(size) => {
              setDealershipTablePageSize(size);
              setDealershipTablePage(0);
            }}
          />

          <div
            style={{
              display: "flex",
              gap: 24,
              marginTop: 12,
              paddingTop: 8,
              fontSize: 13,
              fontWeight: 600,
              flexWrap: "wrap",
              alignItems: "center",
              justifyContent:'end',
              marginRight:10
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
              <div
                style={{
                  width: 12,
                  height: 12,
                  background: "#9ba3a8",
                  borderRadius: 2,
                }}
              />
              Contracts with CC
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
              <div
                style={{
                  width: 12,
                  height: 12,
                  background: "#f5a26f",
                  borderRadius: 2,
                }}
              />
              Contracts without CC
            </div>
          </div>
        </div>
        
      </Grid>
    </Grid>
  );
};

  return (
    <div className="Dashboard">
      <div className={classes.grow}>
        {/* <AnnouncmentBanner/> */}
        <Grid
          container
          direction="row"
          justify="center"
          alignItems="center"
          className={classes.subMenu}
        >
          <Grid xs={12} md={3}>
            <div className={classes.search}>
              <Select
                displayEmpty
                value={searchType}
                onChange={handleSearchTypeChange}
                autoWidth={true}
                inputProps={{
                  classes: {
                    root: classes.select,
                  },
                }}
              >
                <MenuItem key="0" value={''}>
                  Select Search Type
                </MenuItem>
                <MenuItem key={'1'} value={'dealership'}>
                  Location
                </MenuItem>
                <MenuItem key={'2'} value={'dealershipGroup'}>
                 Group
                </MenuItem>
              </Select>
            </div>
          </Grid>

          {searchType === 'dealership' && (
            <Grid xs={12} md={3}>
              <div className={classes.search}>
                <Select
                  value={dealershipId}
                  onChange={handleDealershipOptionsDropdown}
                  autoWidth={true}
                  displayEmpty
                  inputProps={{
                    classes: {
                      root: classes.select,
                    },
                  }}
                >
                  {dealershipOptions &&
                    renderDealershipOptions(dealershipOptions)}
                </Select>
              </div>
            </Grid>
          )}
          {searchType === 'dealershipGroup' && (
            <Grid xs={12} md={3}>
              <div className={classes.search}>
                <Select
                  value={dealershipGroupId}
                  onChange={handleDealershipOptionsDropdown}
                  autoWidth={true}
                  displayEmpty
                  inputProps={{
                    classes: {
                      root: classes.select,
                    },
                  }}
                >
                  {dealershipOptions &&
                    renderDealershipGroupOptions(dealershipOptions)}
                </Select>
              </div>
            </Grid>
          )}

          <div className={classes.grow} />
          <Grid xs={12} md={3}>
            <TextField
              id="startDate"
              label="Start Date"
              type="date"
              onChange={handleStartDateChange}
              value={startDate}
              className={classes.textField}
              InputLabelProps={{
                shrink: true,
                className: classes.input,
              }}
              InputProps={{
                className: classes.input,
              }}
            />
          </Grid>
          <Grid xs={12} md={3}>
            <TextField
              id="endDate"
              label="End Date"
              type="date"
              onChange={handleEndDateChange}
              value={endDate}
              className={classes.textField}
              InputLabelProps={{
                shrink: true,
                className: classes.input,
              }}
              InputProps={{
                className: classes.input,
              }}
            />
          </Grid>
        </Grid>
        {/* </AppBar> */}
        <br />
        <br />
        <Divider />
        <br />

        <div style={{ position: 'relative' }}>
          {blurDashboard && (
            <div
              style={{
                position: 'absolute',
                inset: 0,
                zIndex: 10,
                borderRadius: 12,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <CircularProgress size={32} style={{ color: '#424242' }} />
            </div>
          )}
          <Grid container spacing={2} style={{ position: 'relative', zIndex: 1 }}>
            {newMetrics.map(({ key, pastKey, title }) => {
              const curr = Number(dashboard[key]);
              const hasPast = pastKey in dashboard;
              const past = hasPast ? Number(dashboard[pastKey as keyof IStatistics]) : 0;
              const ratio = hasPast && past ? curr / past : 1;
              const isReversed = ['declinedInvSum', 'InvoiceWithoutAuthTokenSum'].includes(key);
              const border = hasPast
                ? isReversed
                  ? ratio > 1.35 ? 'red' : ratio > 1.15 ? 'rgb(249, 177, 34)' : undefined
                  : ratio < 0.65 ? 'red' : ratio < 0.85 ? 'rgb(249, 177, 34)' : undefined
                : undefined;

              return (
                <Grid item xs={12} md={4} key={key}>
                  <div style={{ position: 'relative', borderRadius: 12, overflow: 'hidden' }}>
                    {blurDashboard && (
                      <div
                        style={{
                          position: 'absolute',
                          inset: 0,
                          backdropFilter: 'blur(6px)',
                          backgroundColor: 'rgba(240, 240, 240, 0.37)',
                          zIndex: 2,
                        }}
                      />
                    )}
                    <Card
                      variant="outlined"
                      style={{
                        border: '1.5px solid',
                        borderColor: border,
                        borderRadius: 12,
                        padding: 16,
                        boxShadow: '0 2px 6px rgba(0,0,0,0.08)',
                      }}
                    >
                      <CardContent style={{ padding: 0 }}>
                        <Typography color="textSecondary" gutterBottom style={{ fontWeight: 500 }}>
                          {title}
                        </Typography>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: 16 }}>
                          <div style={{ width: 100, textAlign: 'center', marginRight: 16 }}>
                            <Typography variant="h6" style={{ fontWeight: 600 }}>
                              {formatMoney(key, curr)}
                            </Typography>
                          </div>
                          {hasPast && (
                            <>
                              <div style={{ height: 24, width: 1, backgroundColor: '#ddd', marginRight: 16 }} />
                              <div style={{ width: 150, display: 'flex', alignItems: 'center', gap: 8 }}>
                                {key === 'pendingTollsSum' ? (
                                  <a
                                    href="javascript:void(0)"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      const tollsState = {
                                        dealershipId: dealershipId || 0,
                                        startDate: moment(startDate).subtract(30, 'days').format('YYYY-MM-DD'),
                                        endDate: moment(endDate).subtract(30, 'days').format('YYYY-MM-DD'),
                                      };
                                      sessionStorage.setItem('tollsFilterState', JSON.stringify(tollsState));
                                      window.open('/tolls', '_blank');
                                      setTimeout(() => {
                                        sessionStorage.removeItem('tollsFilterState');
                                      }, 200);
                                    }}
                                    style={{ textDecoration: 'none', color: 'inherit', display: 'flex', alignItems: 'center', gap: 6 }}
                                  >
                                    <span>
                                      <Typography variant="body2" color="textSecondary" style={{ fontSize: 13 }}>
                                        {formatMoney(key, past)} <span style={{ fontStyle: 'italic' }}>(previous)</span>
                                      </Typography>
                                    </span>
                                    <FontAwesomeIcon icon={faArrowUpRightFromSquare} style={{ fontSize: 12, color: '#757575' }} />
                                  </a>
                                ) : (
                                  <Typography variant="body2" color="textSecondary" style={{ fontSize: 13 }}>
                                    {formatMoney(key, past)} <span style={{ fontStyle: 'italic' }}>(previous)</span>
                                  </Typography>
                                )}
                              </div>
                            </>
                          )}
                        </div>
                      </CardContent>
                    </Card>
                  </div>
                </Grid>
              );
            })}
          </Grid>

          <br />
          {/* Legend */}
          <Grid container justifyContent="flex-end" spacing={2}>
            <Grid item xs="auto">
              <Box display="flex" alignItems="center">
                <Box width={16} height={16} bgcolor="rgb(249, 177, 34)" borderRadius={2} mr={1} />
                <Typography variant="body2" color="textSecondary">{'>'} 15% deviation from previous period</Typography>
              </Box>
            </Grid>
            <Grid item xs="auto">
              <Box display="flex" alignItems="center">
                <Box width={16} height={16} bgcolor="red" borderRadius={2} mr={1} />
                <Typography variant="body2" color="textSecondary">{'>'} 35% deviation from previous period</Typography>
              </Box>
            </Grid>
          </Grid>
        </div>
        <br />
        <Divider />
        <br />

        {!!saRecords.dealerships.length && (
          <>
            {renderDealershipTable()}
            <br />
            <br />
            <Divider />
          </>
        )}

        {!!saRecords.saDetails.length && renderSATable()}

        {!!saRecords.length && (
          <>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography variant={'h6'} align={'left'}>
                  Service Advisor Information
                </Typography>
              </Grid>
              {/* <div className={classes.search}> */}
              <Select
                value={saOption}
                onChange={handleSAOptionsDropdown}
                autoWidth={true}
                displayEmpty
              // inputProps={{
              //   classes: {
              //     root: classes.select,
              //   },
              // }}
              >
                {saRecords && renderSAOptions(saRecords)}
              </Select>
              {/* </div> */}
            </Grid>
            <br />
            <br />
            {saDetails && (
              <Grid container spacing={2}>
                {Object.keys(saDetails).map((statistic: string) => {
                  return (
                    <Grid item xs={12} md={3}>
                      <Card>
                        <CardContent>
                          <Typography
                            // className={classes.title}
                            color="textSecondary"
                            gutterBottom
                          >
                            {
                              sAStatisticTitles[
                              statistic as keyof ISAStatisticsTitles
                              ]
                            }
                          </Typography>
                          <Typography variant="h5" component="h2">
                            {formatMoney(
                              statistic,
                              saDetails[statistic as keyof ISAStatistics]
                            )}
                          </Typography>
                        </CardContent>
                      </Card>
                    </Grid>
                  );
                })}
              </Grid>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default Dashboard;
